import { tryDoFetch } from "lib/tryDoFetch";
import { useEffect, useState } from "react";

export const useIsSubscribedToAnalyst = (analyst) => {
  const url = "/research/japi/subscription/analyst/" + analyst.fullName.en;
  const deleteUrl = "/research/japi/subscription/delete/analyst/" + analyst.fullName.en;
  const [state, setState] = useState({ isLoading: true });

  useEffect(() => {
    const fetchData = async () => {
      const data = await tryDoFetch(url, null, "GET", onError);
      setState(isBoolean(data?.response) ? { isSubscribed: data.response } : { err: "unexpected response" });
    };
    fetchData();
  }, [url]);

  const changeSubscription = async (shldSubscribe) => {
    setState({ isLoading: true });
    const method ="POST" ;
    const url2 = shldSubscribe ? url : deleteUrl;
    const data = await tryDoFetch(url2, null, method, onError);
    setState(isBoolean(data?.response) ? { isSubscribed: shldSubscribe } : { err: "unexpected response" });
  };

  const onError = (err) => setState({ err });

  return [state, changeSubscription];
};

const isBoolean = (b) => typeof b === "boolean";
